import React from 'react';
import FormModal from "../../../components/common/modals/FormModal";
import graphql from "babel-plugin-relay/macro";
import {useMutation} from "react-relay";
import HorizontalFormDate from "../../../components/common/horizontal-form-inputs/HorizontalFormDate";
import {toast} from "react-toastify";
import HorizontalFormSelect from "../../../components/common/horizontal-form-inputs/HorizontalFormSelect";
import {createOptions} from "../../../helpers/utils";
import {useForm} from "react-hook-form";
import {useFragment} from "react-relay";
import dayjs from "dayjs";
import HorizontalFormMultiCheck from "../../../components/common/horizontal-form-inputs/HorizontalFormMultiCheck";
const TermLocationsModal = ({showModal, onClose, practitionerLocations}) => {
    const mutation = graphql`
    mutation TermLocationsModalMutation($practitionerLocationIds: [ID!]!, $effectiveDate: DateOnly!) {
      practitionerLocation {
          termPractitionerLocation(input: {effectiveDate: $effectiveDate,practitionerLocationIds: $practitionerLocationIds }){
              practitionerLocations {
                  ...PractitionerLocations_Locations
              }
          }
      }  
    }`
    const fragment = graphql`
    fragment TermLocationsModal_LocationDropdown on PractitionerLocation @relay(plural:true) {
        id
        status
        location {
            addressLine1
            addressLine2
            city
            state
            postalCode
            applicableVersion {
                name
            }
        }
        legalContractLineOfService {
            id
            lineOfService {
                name
            }
        
    }}`
    const practitionerLocationOptions = createOptions(useFragment(fragment, practitionerLocations), "id", x => {
        return `(${x.status}) ${x.location.applicableVersion.name} ${x.location.addressLine1} ${x.location.addressLine2}, ${x.location.city} ${x.location.state} ${x.location.postalCode}. ${x.legalContractLineOfService.lineOfService.name}`
    })
    const [commitMutation, isInFlight] = useMutation(mutation)
    const defaultValues = {
        effectiveDate: dayjs().startOf('day').toDate()
    }
    const methods = useForm({values: defaultValues})
    const handleSubmit = (data) => {
        commitMutation({variables: {...data}, onCompleted: (data) => {
                if(data.practitionerLocation) {
                    toast.success("Locations termed");
                    methods.reset();
                    onClose();
                }
            }})
    }
    return (
        <FormModal showModal={showModal} onClose={onClose} title={"Term Selected Locations"} 
                   methods={methods} isInFlight={isInFlight} onSubmit={handleSubmit}>
            <HorizontalFormMultiCheck controlId={"practitionerLocationIds"} label={"Locations"} options={practitionerLocationOptions} />
            <HorizontalFormDate controlId={"effectiveDate"} label={"Term Date"} /> 
        </FormModal>
    )
}
export default TermLocationsModal